import React, { useRef, useState } from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { Button, Dialog, Menu, MenuItem } from "@mui/material";
const colors = [
  "#ff1100",
  "#0800ff",
  "#04ff00",
  "#ff00f7",
  "#ffff00",
  "#379294",
  "#943766",
  "#37945f",
  "#000000",
  "#462594",
];
const PetCardMove = ({
  type,
  id,
  text,
  index,
  pindex,
  mode,
  setModeItem,
  moveListItem,
  removeItem,
  handleOpen,
}) => {
  const [openD, setOpenD] = useState(false);
  const handleClose = () => {
    setOpenD(false);
  };

  const petColor = (mode) => {
    let color = "#a6a6a6";
    switch (mode) {
      case "user":
        color = "#f59090";
        break;
      case "title":
        color = "#49f56c";
        break;
      case "text":
        color = "#30bff2";
        break;
      default:
        color = "#a6a6a6";
    }
    return color;
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        minWidth: 35,
        paddingRight: 2,
        paddingLeft: 2,
        height: 35,
        fontSize: 13,
        backgroundColor: petColor(mode ? mode : type),
        margin: 2,
        borderRadius: 17,
        textAlign: "center",
        boxShadow: "2px 2px gray",
      }}
      // onClick={() => {
      //   handleOpen(index, type);
      // }}
    >
      <div
        style={{
          width: "90%",
          color: id == ")" || id == "(" ? colors[pindex] : "#000",
          justifyContent: "center",
          //fontWeight: type !== "que" ? "bold" : "unset",
          // fontSize: type == "que" ? 13 : "unset",
          lineHeight: "30px",
          overflow: "hidden",
          cursor: "pointer",
        }}
        title={text}
      >
        {text}
      </div>
      <div
        style={{
          marginTop: -5,
          marginInlineEnd: -5,
          cursor: "pointer",
        }}
        onClick={() => {
          //setOpenD(true);
          //removeItem(index);
          handleOpen(index, type);
        }}
      >
        <DragIndicatorIcon
          size="small"
          aria-label="Device settings"
          style={{
            color: "red",
            width: 15,
          }}
        />
      </div>
    </div>
  );
};

export default PetCardMove;
